module.exports = __webpack_public_path__ + "img/header.810c667c.jpg";